<div class="flex flex-column">
  <div class="inline-flex mt-2">
    <span class="col-fixed p-0 mr-2" [style.width.px]="20" *ngIf="!catalog.catalog">
      <p-checkbox [name]="catalog.id! + '--checkbox'" [(ngModel)]="catalog.filled"
        (ngModelChange)="handleChange(true)" [binary]="true"></p-checkbox>
    </span>

    <label class="col p-0 mb-0 font-semibold" [style.marginTop]="'2px!important'"
      for="input-name_{{catalog.id}}_{{catalog.turn}}" (click)="handleLabelClick()">
      {{catalog.name}}
    </label>
  </div>

  <div class="mt-2" *ngIf="catalog.filled">
    <p-radioButton name="radio-name_{{catalog.id}}_{{catalog.turn}}" [value]="true" [(ngModel)]="catalog.withEvidence"
      [disabled]="readonly" label="CP"></p-radioButton>
    <p-radioButton name="radio-name_{{catalog.id}}_{{catalog.turn}}" [value]="false"
      [(ngModel)]="catalog.withEvidence" [disabled]="readonly" label="SP" styleClass="ml-2"></p-radioButton>
  </div>

  <div class="mt-2" *ngIf="catalog.filled">
    <textarea pInputTextarea name="input-name_{{catalog.id}}_{{catalog.turn}}" [(ngModel)]="catalog.details"
      (ngModelChange)="handleChange()" [rows]="2" validation [disabled]="!catalog.filled"
      [required]="catalog.filled && !readonly" [readonly]="readonly" class="uppercase">
      </textarea>
  </div>
</div>